import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-personal-details',
  templateUrl: './personal-details.page.html',
  styleUrls: ['./personal-details.page.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule]
})
export class PersonalDetailsPage {
  @Input()
  detailsForm: FormGroup | undefined;
}